import { useMutation, useQueryClient } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/helpers'
import { AdminConsoleDashboardsApi } from '@portal/pkg-api/admin-console'
import type {
  CreateDashboardRequest,
  UpdateDashboardRequest,
} from '@portal/pkg-api/gen/admin-console'
import { DashboardQueries } from './queries'

const prefix = 'admin-console.dashboards'

export const DashboardMutations = {
  deleteDashboard: () => ({
    mutationKey: [prefix, 'deleteDashboard'],
    mutationFn: ({ id }: { id: number }) => data(AdminConsoleDashboardsApi.deleteDashboard(id)),
  }),
  createDashboard: () => ({
    mutationKey: [prefix, 'createDashboard'],
    mutationFn: (request: CreateDashboardRequest) =>
      data(AdminConsoleDashboardsApi.createDashboard(request)),
  }),
  updateDashboard: () => ({
    mutationKey: [prefix, 'updateDashboard'],
    mutationFn: ({ id, ...request }: { id: number } & UpdateDashboardRequest) =>
      data(AdminConsoleDashboardsApi.updateDashboard(id, request)),
  }),
}

export function useDeleteDashboard() {
  const queryClient = useQueryClient()
  return useMutation({
    ...DashboardMutations.deleteDashboard(),
    onSuccess: () => {
      // Every type filter shares the row that was removed, so drop the whole list branch.
      void queryClient.invalidateQueries({ queryKey: [prefix, 'list'] })
    },
  })
}

export function useCreateDashboard() {
  const queryClient = useQueryClient()
  return useMutation({
    ...DashboardMutations.createDashboard(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [prefix, 'list'] })
    },
  })
}

export function useUpdateDashboard() {
  const queryClient = useQueryClient()
  return useMutation({
    ...DashboardMutations.updateDashboard(),
    onSuccess: (_result, { id }) => {
      void queryClient.invalidateQueries({ queryKey: [prefix, 'list'] })
      void queryClient.invalidateQueries(DashboardQueries.detail(id))
    },
  })
}
